import { render, staticRenderFns } from "./DocumentNew.vue?vue&type=template&id=c993a74c&"
import script from "./DocumentNew.vue?vue&type=script&lang=js&"
export * from "./DocumentNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports